import { Action } from '../actions';

const defaultState = null;

export default function (state = defaultState, action) {
  switch (action.type) {
    case Action.Station.SetStation:
      return action.station;
    case Action.Station.EditStation:
      return {
        ...state,
        ...action.stationEdit,
      };
    default:
      return state;
  }
}
